import { UPDATE_STORE_DATA_FIELD } from '../constants/actionTypes';

// eslint-disable-next-line import/prefer-default-export
export function updateStoreDataField({ field, value }) {
  return dispatch => dispatch({ type: UPDATE_STORE_DATA_FIELD, payload: { field, value } });
}
